/**
 * Custom hook for reCAPTCHA v3 token generation.
 *
 * The @dpdgroupuk/react-google-recaptcha-v3 library loads the script with
 * `render=explicit` and resolves its internal promise with a widget ID (integer).
 * Calling `grecaptcha.execute(widgetId, { action })` is the v2 API — the `action`
 * param is ignored and it triggers an interactive challenge.
 *
 * For reCAPTCHA v3 the correct call is:
 *   grecaptcha.execute(SITEKEY_STRING, { action })
 * which returns a score-based token silently, with no user interaction.
 *
 * This hook waits for `grecaptcha` to be ready (injected by the Provider),
 * then calls execute directly with the sitekey from the environment.
 */
const useRecaptcha = () => {
  const executeRecaptchaV3 = async action => {
    await new Promise(resolve => window.grecaptcha.ready(resolve));
    return window.grecaptcha.execute(import.meta.env.VITE_RECAPTCHA_SITE_KEY, {
      action,
    });
  };

  return { executeRecaptchaV3 };
};

export default useRecaptcha;
